// anime.js - https://animejs.com/
import anime from 'animejs/lib/anime.es.js';

// numberal.js - http://numeraljs.com/
import numeral from 'numeral';

let timelines = [];

const initialiseCounter = () => {
  const counterTimeline = anime.timeline({
    duration: 3500,
  });

  counterTimeline.add({
    targets: '.js--containers-counter',
    innerHTML: [0, 570],
    easing: 'linear',
    round: 1,
    autoplay: false,
    delay: 1500,
    update: (a) => {
      // Format the number correctly based on it's value, using numeral.js.
      const value = a.animations[0].currentValue;
      // The application also needs to add 'million' to the end value.
      const formattedNumber = `${numeral(value).format('0,000,000')} million`;
      document.getElementsByClassName('js--containers-counter')[0].innerHTML = formattedNumber;
    },
  });

  timelines.push(counterTimeline);
};

const playTimelines = () => {
  timelines.forEach((timeline) => {
    timeline.play();
  });
};

exports.initialiseCounter = initialiseCounter;
exports.playTimelines = playTimelines;
